import type { LitElementComs } from '@mfe/lit/LitElementComs';
import { html } from 'lit';

// This is just for testing
export const forTesting = function render(this: LitElementComs) : ReturnType<typeof html> {
  return html`<p>${this.loadedResourcesCount}</p>`;
};
